
import medalOneImage from '../assets/medals/medal_1.png';
import medalTwoImage from '../assets/medals/medal_2.png';
import medalThreeImage from '../assets/medals/medal_3.png';
import medalFourImage from '../assets/medals/medal_4.png';
import medalFiveImage from '../assets/medals/medal_5.png';
import medalSixImage from '../assets/medals/medal_6.png';
import medalSevenImage from '../assets/medals/medal_7.png';
import medalEightImage from '../assets/medals/medal_8.png';
import medalNineImage from '../assets/medals/medal_9.png';
import medalTenImage from '../assets/medals/medal_10.png';

export const medals = [
  {
    background_vertical: "linear-gradient(180deg,rgba(255, 175, 28, 1) 0%, rgba(253, 242, 205, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(255, 175, 28, 1) 0%, rgba(253, 242, 205, 1) 100%);",
    image: medalOneImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(46, 116, 255, 1) 0%, rgba(146, 235, 255, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(46, 116, 255, 1) 0%, rgba(146, 235, 255, 1) 100%);",
    image: medalTwoImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(102, 204, 102, 1) 0%, rgba(249, 255, 72, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(102, 204, 102, 1) 0%, rgba(249, 255, 72, 1) 100%);",
    image: medalThreeImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(255, 85, 108, 1) 0%, rgba(255, 185, 46, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(255, 85, 108, 1) 0%, rgba(255, 185, 46, 1) 100%);",
    image: medalFourImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(178, 104, 201, 1) 0%, rgba(116, 211, 255, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(178, 104, 201, 1) 0%, rgba(116, 211, 255, 1) 100%);",
    image: medalFiveImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(252, 255, 47, 1) 0%, rgba(255, 232, 147, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(252, 255, 47, 1) 0%, rgba(255, 232, 147, 1) 100%);",
    image: medalSixImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(169, 255, 163, 1) 0%, rgba(64, 224, 208, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(169, 255, 163, 1) 0%, rgba(64, 224, 208, 1) 100%);",
    image: medalSevenImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(255, 105, 180, 1) 0%, rgba(196, 1, 75, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(255, 105, 180, 1) 0%, rgba(196, 1, 75, 1) 100%);",
    image: medalEightImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(22, 106, 179, 1) 0%, rgba(192, 90, 255, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(22, 106, 179, 1) 0%, rgba(192, 90, 255, 1) 100%);",
    image: medalNineImage,
  },
  {
    background_vertical: "linear-gradient(180deg,rgba(31, 243, 121, 1) 0%, rgba(0, 162, 154, 1) 100%);",
    background_horizontal: "linear-gradient(140deg,rgba(31, 243, 121, 1) 0%, rgba(0, 162, 154, 1) 100%);",
    image: medalTenImage,
  },
]